<template>
  <div class="pwdDiv">
    <div class="cont1">
      {{
        Number(isReset) === 0
          ? "首次使用请先修改密码！"
          : "修改密码后原密码将立即失效！"
      }}
    </div>
    <div class="cont2">
      <van-field
        v-model="oldPwd"
        label="原密码"
        placeholder="请输入原密码"
        style="margin-bottom: 10px;padding: 13px 16px;background: #fff;"
      />
      <van-field
        v-model="newPwd"
        label="新密码"
        placeholder="请输入8~32位的密码"
        style="margin-bottom: 10px;padding: 13px 16px;background: #fff;"
      />
    </div>
    <div class="footer-cont2">
      <van-button type="primary" block class="btnStyle1" @click="saveCheck"
        >保存</van-button
      >
      <van-button
        block
        class="btnStyle2"
        v-if="Number(isReset) !== 0"
        @click="
          $router.push({
            path: 'rhwxWelcome'
          })
        "
        >取消</van-button
      >
    </div>

    <!-- 弹窗 -->
    <van-dialog
      v-model="dialogShow"
      show-cancel-button
      title="注意"
      :showConfirmButton="false"
      :showCancelButton="false"
    >
      <template #default>
        <div class="dialog-blk">
          <div>
            确定要修改登录密码吗？<br />
            <span class="colorPink">修改后原密码将立即失效！</span>
          </div>
        </div>
        <div style="display: flex;">
          <div style="flex: 1;" @click="dialogShow = false">
            <van-button block class="dialogBtnCancel">
              取消
            </van-button>
          </div>
          <div style="flex: 1;" @click="save">
            <van-button block class="dialogBtnConfirm" @click="saveCheck"
              >确认保存</van-button
            >
          </div>
        </div>
      </template>
    </van-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      oldPwd: "",
      newPwd: "",
      dialogShow: false
    };
  },
  created() {},
  methods: {
    saveCheck() {
      if (this.oldPwd.trim() === "") {
        this.$common.mbToastFail("原密码不能为空");
        return false;
      }
      if (this.newPwd.trim() === "") {
        this.$common.mbToastFail("新密码不能为空");
        return false;
      }
      console.log(
        !/(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z\\W]{8,32}$/.test(this.newPwd)
      );
      if (
        !/(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z\\W]{8,32}$/.test(this.newPwd) ||
        this.newPwd.length < 8 ||
        this.newPwd.length > 32
      ) {
        this.$common.mbToastFail("新密码为8~32位，并且至少包含数字、字母");
        return false;
      }
      this.dialogShow = true;
    },

    save() {
      this.dialogShow = false;
      this.$common
        .http({
          url: "/api/pcenter/reset_password",
          data: {
            old_password: this.oldPwd,
            new_password: this.newPwd
          }
        })
        .then(() => {
          this.$common
            .http({
              url: "/api/supplier/account_info"
            })
            .then(res1 => {
              this.$common.mbToastSuccess("修改成功");
              setTimeout(() => {
                let isComplete = Number(res1.data.data.is_complete);
                if (isComplete === 1) {
                  // 跳转合作单位页面 rhwxWelcome
                  this.$router.push({ path: "/rhwxWelcome" });
                } else {
                  // rhwxInfoModify
                  this.$router.push({
                    path: "/rhwxInfoModify",
                    query: {
                      is_complete: isComplete
                    }
                  });
                }
              }, 1500);
            });
        });
    }
  },
  computed: {
    isReset() {
      return this.$route.query.is_reset;
    }
  }
};
</script>
<style lang="less">
@import "../assets/css/common";
.pwdDiv {
  height: 100%;
  background: #f4f5f6;
  .cont1 {
    color: #ec3f67;
    font-size: 17px;
    text-align: center;
    line-height: 49px;
  }
}
</style>
